import React, { useState, useEffect } from 'react';
import {
  View,
  Text,
  StyleSheet,
  ScrollView,
  TouchableOpacity,
  TextInput,
  Image,
  SafeAreaView,
  Alert,
  Platform,
  ActivityIndicator,
  Dimensions,
} from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { LinearGradient } from 'expo-linear-gradient';
import { useTheme } from '../screens/ThemeContext';
import { useAuth } from '../private/AuthContext';
import * as ImagePicker from 'expo-image-picker';
import { doc, updateDoc, getDoc, serverTimestamp } from 'firebase/firestore';
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { db } from '../private/firebaseConfig';

const { width } = Dimensions.get('window');

export default function EditContentScreen({ route, navigation }) {
  const { announcement } = route.params;
  const { theme } = useTheme();
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [formValid, setFormValid] = useState(false);
  const [centerData, setCenterData] = useState(null);
  const [uploading, setUploading] = useState(false);

  const [formData, setFormData] = useState({
    titre: announcement.titre || '',
    description: announcement.description || '',
    image: announcement.imageUrl || null,
    concours: announcement.concours || [''],
    // dateDebut: announcement.dateDebut ? new Date(announcement.dateDebut.seconds * 1000) : new Date(),
    // dateFin: announcement.dateFin ? new Date(announcement.dateFin.seconds * 1000) : new Date(),
    avantages: announcement.avantages || [
      { titre: '', description: '' }
    ],
    liensUtiles: (announcement.liensUtiles || []).map((l) => ({
      id: l.id || (Date.now().toString(36) + Math.random().toString(36).slice(2, 5)),
      titre: l.titre || '',
      url: l.url || '',
    })),
    contact: announcement.contact || {
      telephone: '',
      whatsapp: '',
      email: '',
    }
  });

  const addLienUtile = () => {
    setFormData((prev) => ({
      ...prev,
      liensUtiles: [
        ...(prev.liensUtiles || []),
        { id: Date.now().toString(36) + Math.random().toString(36).slice(2, 5), titre: '', url: '' },
      ],
    }));
  };
  const updateLienUtile = (id, field, value) => {
    setFormData((prev) => ({
      ...prev,
      liensUtiles: (prev.liensUtiles || []).map((l) => (l.id === id ? { ...l, [field]: value } : l)),
    }));
  };
  const removeLienUtile = (id) => {
    setFormData((prev) => ({
      ...prev,
      liensUtiles: (prev.liensUtiles || []).filter((l) => l.id !== id),
    }));
  };
  const insertLinkInDescription = () => {
    const url = typeof window !== 'undefined' ? window.prompt('URL du lien :', 'https://') : '';
    if (!url || !url.trim()) return;
    const label = typeof window !== 'undefined' ? (window.prompt('Texte du lien :', 'texte') || 'lien') : 'lien';
    const md = `[${label}](${url.trim()})`;
    setFormData((prev) => ({
      ...prev,
      description: (prev.description || '') + (prev.description ? ' ' : '') + md,
    }));
  };

  useEffect(() => {
    fetchCenterData();
  }, []);

  useEffect(() => {
    validateForm();
  }, [formData]);

  const fetchCenterData = async () => {
    try {
      if (!user) return;
      const centerRef = doc(db, 'centers', user.uid);
      const centerDoc = await getDoc(centerRef);
      if (centerDoc.exists()) {
        setCenterData(centerDoc.data());
      } else {
        console.error('No center data found');
      }
    } catch (error) {
      console.error('Error fetching center data:', error);
    }
  };

  const validateForm = () => {
    const isValid = Boolean(
      formData.titre?.trim() &&
      formData.description?.trim() &&
      formData.image &&
      formData.concours.every(c => c.trim()) &&
      formData.contact.telephone?.trim() &&
      formData.contact.whatsapp?.trim() &&
      formData.contact.email?.trim()
    );
    setFormValid(isValid);
  };

  const pickImage = async () => {
    try {
      const result = await ImagePicker.launchImageLibraryAsync({
        mediaTypes: ImagePicker.MediaTypeOptions.Images,
        allowsEditing: true,
        // aspect: [16, 9],
        quality: 0.8,
      });

      if (!result.canceled) {
        setFormData(prev => ({
          ...prev,
          image: result.assets[0].uri
        }));
      }
    } catch (error) {
      Alert.alert('Erreur', 'Impossible de sélectionner l\'image');
    }
  };

  const addConcours = () => {
    setFormData(prev => ({
      ...prev,
      concours: [...prev.concours, '']
    }));
  };

  const removeConcours = (index) => {
    if (formData.concours.length > 1) {
      setFormData(prev => ({
        ...prev,
        concours: prev.concours.filter((_, i) => i !== index)
      }));
    }
  };

  const updateConcours = (index, value) => {
    setFormData(prev => {
      const newConcours = [...prev.concours];
      newConcours[index] = value;
      return { ...prev, concours: newConcours };
    });
  };

  const addAvantage = () => {
    setFormData(prev => ({
      ...prev,
      avantages: [...prev.avantages, { titre: '', description: '' }]
    }));
  };

  const removeAvantage = (index) => {
    if (formData.avantages.length > 1) {
      setFormData(prev => ({
        ...prev,
        avantages: prev.avantages.filter((_, i) => i !== index)
      }));
    }
  };

  const updateAvantage = (index, field, value) => {
    setFormData(prev => {
      const avantages = [...prev.avantages];
      avantages[index] = { ...avantages[index], [field]: value };
      return { ...prev, avantages };
    });
  };

  // const showDatePicker = async (dateType) => {
  //   if (Platform.OS === 'android') {
  //     try {
  //       const { action, year, month, day } = await DatePickerAndroid.open({
  //         date: dateType === 'debut' ? formData.dateDebut : formData.dateFin,
  //         mode: 'default',
  //       });

  //       if (action !== DatePickerAndroid.dismissedAction) {
  //         const selectedDate = new Date(year, month, day);
  //         setFormData(prev => ({
  //           ...prev,
  //           [dateType === 'debut' ? 'dateDebut' : 'dateFin']: selectedDate
  //         }));
  //       }
  //     } catch ({ code, message }) {
  //       console.warn('Cannot open date picker', message);
  //     }
  //   }
  // };

  const uploadImage = async (uri) => {
    // Si l'image n'a pas changé, retourner l'URL existante
    if (uri === announcement.imageUrl) {
      return uri;
    }

    if (!uri) return null;
    const response = await fetch(uri);
    const blob = await response.blob();
    const storage = getStorage();
    const fileName = `announcements/${Date.now()}_${Math.random().toString(36).substring(7)}`;
    const storageRef = ref(storage, fileName);
    const uploadTask = uploadBytesResumable(storageRef, blob);

    return new Promise((resolve, reject) => {
      uploadTask.on('state_changed',
        (snapshot) => {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          setUploading(true);
        },
        (error) => {
          setUploading(false);
          reject(error);
        },
        async () => {
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
          setUploading(false);
          resolve(downloadURL);
        }
      );
    });
  };

  const handleSubmit = async () => {
    if (!formValid || loading) return;
  
    try {
      setLoading(true);
  
      if (!user?.uid) {
        Alert.alert('Erreur', 'Utilisateur non authentifié');
        return;
      }
  
      const imageUrl = await uploadImage(formData.image);
  
      const announcementData = {
        titre: formData.titre,
        description: formData.description,
        imageUrl,
        concours: formData.concours.filter(c => c.trim()),
        // dateDebut: formData.dateDebut,
        // dateFin: formData.dateFin,
        avantages: formData.avantages.filter(a => a.titre.trim() && a.description.trim()),
        liensUtiles: (formData.liensUtiles || []).filter((l) => l.url && l.url.trim()).map((l) => ({ titre: (l.titre || '').trim() || l.url.trim(), url: l.url.trim() })),
        contact: formData.contact,
        centerInfo: {
          centerId: user.uid,
          centerName: centerData?.centerName || 'Non spécifié',
          centerAddress: centerData?.address || 'Non spécifié',
        },
        updatedAt: serverTimestamp(),
      };
  
      await updateDoc(doc(db, 'announcements', announcement.id), announcementData);
      Alert.alert('Succès', 'Annonce mise à jour avec succès !');
      navigation.goBack();
  
    } catch (error) {
      console.error('Error updating announcement:', error);
      Alert.alert('Erreur', 'Une erreur est survenue lors de la mise à jour');
    } finally {
      setLoading(false);
    }
  };

  const renderDateInput = (dateType, date) => (
    <TouchableOpacity
      style={styles.dateInput}
      onPress={() => showDatePicker(dateType)}
    >
      <Text style={{ color: theme.text }}>
        {dateType === 'debut' ? 'Date de début: ' : 'Date de fin: '}
        {date.toLocaleDateString()}
      </Text>
      <MaterialCommunityIcons name="calendar" size={20} color={theme.textSecondary} />
    </TouchableOpacity>
  );

  const styles = StyleSheet.create({
    safeArea: {
      flex: 1,
      backgroundColor: theme.primary,
    },
    container: {
      flex: 1,
      backgroundColor: theme.background,
    },
    header: {
      flexDirection: 'row',
      alignItems: 'center',
      padding: 16,
    },
    backButton: {
      padding: 8,
      borderRadius: 12,
      marginRight: 15,
    },
    headerTitle: {
      fontSize: 20,
      fontWeight: 'bold',
    },
    content: {
      flex: 1,
      padding: 20,
      paddingTop: 10,
      
      marginBottom: 100,
    },
    section: {
      marginBottom: 20,
      backgroundColor: theme.surface,
      borderRadius: 16,
      padding: 16,
      borderWidth: 1,
      borderColor: theme.border,
    },
    sectionTitle: {
      fontSize: 18,
      fontWeight: '700',
      color: theme.text,
      marginBottom: 15,
      letterSpacing: 0.3,
    },
    imageContainer: {
      height: 200,
      backgroundColor: theme.surface,
      borderRadius: 16,
      marginTop: 10,
      overflow: 'hidden',
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: 20,
      borderWidth: 2,
      borderColor: theme.primary + '30',
      borderStyle: 'dashed',
    },
    previewImage: {
      width: '100%',
      height: '100%',
      borderRadius: 16,
    },
    uploadText: {
      color: theme.textSecondary,
      marginTop: 10,
      fontSize: 14,
    },
    input: {
      backgroundColor: theme.background,
      borderRadius: 12,
      padding: 15,
      color: theme.text,
      marginBottom: 15,
      fontSize: 16,
      borderWidth: 1,
      borderColor: theme.border,
    },
    textArea: {
      height: 120,
      textAlignVertical: 'top',
      paddingTop: 15,
    },
    concoursContainer: {
      marginBottom: 10,
    },
    concoursInputContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: 12,
      backgroundColor: theme.background,
      borderRadius: 12,
      borderWidth: 1,
      borderColor: theme.border,
      paddingRight: 8,
    },
    concoursInput: {
      flex: 1,
      padding: 15,
      color: theme.text,
      fontSize: 16,
    },
    iconButton: {
      padding: 8,
      borderRadius: 10,
      backgroundColor: theme.primary + '15',
    },
    addButton: {
      flexDirection: 'row',
      alignItems: 'center',
      padding: 15,
      borderRadius: 12,
      backgroundColor: theme.primary + '15',
      justifyContent: 'center',
    },
    addButtonText: {
      color: theme.primary,
      marginLeft: 8,
      fontWeight: '600',
      fontSize: 16,
    },
    dateInput: {
      backgroundColor: theme.background,
      borderRadius: 12,
      padding: 15,
      marginBottom: 15,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      borderWidth: 1,
      borderColor: theme.border,
    },
    dateText: {
      fontSize: 16,
      color: theme.text,
    },
    avantageCard: {
      backgroundColor: theme.background,
      borderRadius: 12,
      padding: 16,
      marginBottom: 15,
      borderWidth: 1,
      borderColor: theme.border,
    },
    avantageHeader: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 15,
    },
    avantageTitle: {
      fontSize: 16,
      fontWeight: '600',
    },
    contactInput: {
      backgroundColor: theme.background,
      borderRadius: 12,
      padding: 15,
      color: theme.text,
      fontSize: 16,
      marginBottom: 15,
      borderWidth: 1,
      borderColor: theme.border,
      flexDirection: 'row',
      alignItems: 'center',
    },
    contactIcon: {
      marginRight: 10,
      width: 24,
    },
    submitButton: {
      backgroundColor: theme.primary,
      borderRadius: 12,
      padding: 18,
      alignItems: 'center',
      marginTop: 30,
      marginBottom: 30,
      shadowColor: theme.primary,
      shadowOffset: { width: 0, height: 4 },
      shadowOpacity: 0.3,
      shadowRadius: 8,
      elevation: 5,
    },
    submitText: {
      color: '#fff',
      fontSize: 18,
      fontWeight: '600',
      letterSpacing: 0.5,
    },
  });


  return (
    <SafeAreaView style={styles.safeArea}>
      <View style={[styles.header, { backgroundColor: theme.background }]}>
        <TouchableOpacity 
          onPress={() => navigation.goBack()}
          style={[styles.backButton, { backgroundColor: theme.surface, borderColor: theme.border }]}
        >
          <MaterialCommunityIcons name="arrow-left" size={24} color={theme.primary} />
        </TouchableOpacity>
        <Text style={[styles.headerTitle, { color: theme.text }]}>
          Modifier l'annonce
        </Text>
      </View>

      <ScrollView style={styles.container}>
        <View style={styles.content}>
          {/* Image Upload */}
          <TouchableOpacity style={styles.imageContainer} onPress={pickImage}>
            {formData.image ? (
              <Image source={{ uri: formData.image }} style={styles.previewImage} />
            ) : (
              <>
                <MaterialCommunityIcons name="image-plus" size={40} color={theme.textSecondary} />
                <Text style={styles.uploadText}>Ajouter une image de couverture</Text>
              </>
            )}
          </TouchableOpacity>

          {/* Titre */}
          <View style={styles.section}>
            <Text style={styles.sectionTitle}>Titre de l'annonce</Text>
            <TextInput
              style={styles.input}
              value={formData.titre}
              onChangeText={(text) => setFormData(prev => ({...prev, titre: text}))}
              placeholder="Entrez le titre"
              placeholderTextColor={theme.textSecondary}
            />
          </View>

          {/* Description */}
          <View style={styles.section}>
            <Text style={styles.sectionTitle}>Description</Text>
            <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 8, gap: 8 }}>
              <TouchableOpacity
                onPress={insertLinkInDescription}
                style={{ flexDirection: 'row', alignItems: 'center', paddingHorizontal: 10, paddingVertical: 6, borderRadius: 8, backgroundColor: theme.primary + '15', gap: 6 }}
              >
                <MaterialCommunityIcons name="link-variant" size={16} color={theme.primary} />
                <Text style={{ color: theme.primary, fontSize: 12, fontWeight: '600' }}>Insérer un lien</Text>
              </TouchableOpacity>
              <Text style={{ fontSize: 11, color: theme.textSecondary, fontStyle: 'italic' }}>[texte](https://...)</Text>
            </View>
            <TextInput
              style={[styles.input, styles.textArea]}
              value={formData.description}
              onChangeText={(text) => setFormData(prev => ({...prev, description: text}))}
              placeholder="Décrivez votre programme"
              placeholderTextColor={theme.textSecondary}
              multiline
              numberOfLines={4}
            />
          </View>

          {/* Liens utiles */}
          <View style={styles.section}>
            <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
              <Text style={styles.sectionTitle}>Liens utiles</Text>
              <TouchableOpacity onPress={addLienUtile} style={{ width: 32, height: 32, borderRadius: 16, backgroundColor: theme.primary, alignItems: 'center', justifyContent: 'center' }}>
                <MaterialCommunityIcons name="plus" size={18} color="#fff" />
              </TouchableOpacity>
            </View>
            {(formData.liensUtiles || []).length === 0 ? (
              <Text style={{ fontSize: 13, color: theme.textSecondary, fontStyle: 'italic' }}>
                Aucun lien. Ajoute des liens externes qui apparaîtront sous l'annonce.
              </Text>
            ) : (
              (formData.liensUtiles || []).map((lien) => (
                <View key={lien.id} style={{ marginBottom: 10, padding: 10, borderRadius: 10, borderWidth: 1, borderColor: theme.border, backgroundColor: theme.background }}>
                  <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: 6 }}>
                    <View style={{ flexDirection: 'row', alignItems: 'center', gap: 6 }}>
                      <MaterialCommunityIcons name="link" size={18} color={theme.primary} />
                      <Text style={{ color: theme.text, fontWeight: '600', fontSize: 13 }}>Lien</Text>
                    </View>
                    <TouchableOpacity onPress={() => removeLienUtile(lien.id)}>
                      <MaterialCommunityIcons name="delete" size={18} color={theme.danger || '#ef4444'} />
                    </TouchableOpacity>
                  </View>
                  <TextInput
                    style={styles.input}
                    value={lien.titre}
                    onChangeText={(t) => updateLienUtile(lien.id, 'titre', t)}
                    placeholder="Titre du lien"
                    placeholderTextColor={theme.textSecondary}
                  />
                  <TextInput
                    style={[styles.input, { marginTop: 8 }]}
                    value={lien.url}
                    onChangeText={(t) => updateLienUtile(lien.id, 'url', t)}
                    placeholder="https://..."
                    placeholderTextColor={theme.textSecondary}
                    autoCapitalize="none"
                  />
                </View>
              ))
            )}
          </View>

          {/* Concours préparés */}
          <View style={styles.section}>
            <Text style={styles.sectionTitle}>Concours préparés</Text>
            {formData.concours.map((concours, index) => (
              <View key={index} style={styles.concoursInputContainer}>
                <TextInput
                  style={styles.concoursInput}
                  value={concours}
                  onChangeText={(text) => updateConcours(index, text)}
                  placeholder="Nom du concours"
                  placeholderTextColor={theme.textSecondary}
                />
                {formData.concours.length > 1 && (
                  <TouchableOpacity 
                    style={styles.iconButton}
                    onPress={() => removeConcours(index)}
                  >
                    <MaterialCommunityIcons name="minus-circle" size={24} color={theme.primary} />
                  </TouchableOpacity>
                )}
              </View>
            ))}
            <TouchableOpacity style={styles.addButton} onPress={addConcours}>
              <MaterialCommunityIcons name="plus" size={24} color={theme.primary} />
              <Text style={styles.addButtonText}>Ajouter un concours</Text>
            </TouchableOpacity>
          </View>

          {/* Durée et Dates */}
          <View style={styles.section}>
            <Text style={styles.sectionTitle}>Période de la formation</Text>
            {Platform.OS === 'web' ? (
              <>
                <label>Date de début :</label>
                <input
                  type="date"
                  value={formData.dateDebut ? formData.dateDebut.toISOString().substr(0, 10) : ''}
                  onChange={e => setFormData(prev => ({ ...prev, dateDebut: new Date(e.target.value) }))}
                  style={{ padding: 8, fontSize: 16 }}
                />
                <label>Date de fin :</label>
                <input
                  type="date"
                  value={formData.dateFin ? formData.dateFin.toISOString().substr(0, 10) : ''}
                  onChange={e => setFormData(prev => ({ ...prev, dateFin: new Date(e.target.value) }))}
                  style={{ padding: 8, fontSize: 16 }}
                />
              </>
            ) : (
              <>
                <TextInput
                  value={formData.dateDebut ? formData.dateDebut.toISOString().substr(0, 10) : ''}
                  editable={false}
                  style={{ padding: 8, fontSize: 16, backgroundColor: '#eee' }}
                />
                <TextInput
                  value={formData.dateFin ? formData.dateFin.toISOString().substr(0, 10) : ''}
                  editable={false}
                  style={{ padding: 8, fontSize: 16, backgroundColor: '#eee' }}
                />
              </>
            )}
          </View>

          {/* Avantages */}
          <View style={styles.section}>
            <View style={styles.sectionHeader}>
              <Text style={styles.sectionTitle}>Pourquoi nous choisir ? (Optionnel)</Text>
              <TouchableOpacity 
                style={styles.iconButton}
                onPress={addAvantage}
              >
                <MaterialCommunityIcons name="plus-circle" size={24} color={theme.primary} />
              </TouchableOpacity>
            </View>
            
            {formData.avantages.map((avantage, index) => (
              <View key={index} style={styles.avantageCard}>
                <View style={styles.avantageHeader}>
                  <Text style={[styles.avantageTitle, { color: theme.text }]}>
                    Avantage {index + 1}
                  </Text>
                  {formData.avantages.length > 1 && (
                    <TouchableOpacity onPress={() => removeAvantage(index)}>
                      <MaterialCommunityIcons name="delete" size={24} color={theme.textSecondary} />
                    </TouchableOpacity>
                  )}
                </View>
                <TextInput
                  style={styles.input}
                  value={avantage.titre}
                  onChangeText={(text) => updateAvantage(index, 'titre', text)}
                  placeholder="Titre de l'avantage"
                  placeholderTextColor={theme.textSecondary}
                />
                <TextInput
                  style={[styles.input, styles.textArea]}
                  value={avantage.description}
                  onChangeText={(text) => updateAvantage(index, 'description', text)}
                  placeholder="Description de l'avantage"
                  placeholderTextColor={theme.textSecondary}
                  multiline
                  numberOfLines={3}
                />
              </View>
            ))}
          </View>

          {/* Contact */}
          <View style={styles.section}>
            <Text style={styles.sectionTitle}>Contact</Text>
            <View style={styles.contactInput}>
              <MaterialCommunityIcons 
                name="phone" 
                size={20} 
                color={theme.primary}
                style={styles.contactIcon}
              />
              <TextInput
                style={{ flex: 1, color: theme.text }}
                value={formData.contact.telephone}
                onChangeText={(text) => setFormData(prev => ({
                  ...prev,
                  contact: { ...prev.contact, telephone: text }
                }))}
                placeholder="Numéro de téléphone"
                placeholderTextColor={theme.textSecondary}
                keyboardType="phone-pad"
              />
            </View>
            
            <View style={styles.contactInput}>
              <MaterialCommunityIcons 
                name="whatsapp" 
                size={20} 
                color={theme.primary}
                style={styles.contactIcon}
              />
              <TextInput
                style={{ flex: 1, color: theme.text }}
                value={formData.contact.whatsapp}
                onChangeText={(text) => setFormData(prev => ({
                  ...prev,
                  contact: { ...prev.contact, whatsapp: text }
                }))}
                placeholder="Numéro WhatsApp"
                placeholderTextColor={theme.textSecondary}
                keyboardType="phone-pad"
              />
            </View>
            
            <View style={styles.contactInput}>
              <MaterialCommunityIcons 
                name="email" 
                size={20} 
                color={theme.primary}
                style={styles.contactIcon}
              />
              <TextInput
                style={{ flex: 1, color: theme.text }}
                value={formData.contact.email}
                onChangeText={(text) => setFormData(prev => ({
                  ...prev,
                  contact: { ...prev.contact, email: text }
                }))}
                placeholder="Adresse email"
                placeholderTextColor={theme.textSecondary}
                keyboardType="email-address"
              />
            </View>
          </View>

          {/* Submit Button */}
          <TouchableOpacity 
            style={[
              styles.submitButton,
              (!formValid || loading) && { opacity: 0.5 }
            ]} 
            onPress={handleSubmit}
            disabled={!formValid || loading}
          >
            {loading ? (
              <ActivityIndicator color="#fff" />
            ) : (
              <Text style={styles.submitText}>Mettre à jour l'annonce</Text>
            )}
          </TouchableOpacity>
        </View>
        <View style={{ height: 7000 }} />
      </ScrollView>
      <View style={[styles.bottomSpace, {flex: 1}, { backgroundColor: theme.background }]} />
    </SafeAreaView>
  );
}